import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useHealth(intervalMs = 60000) {
  const [h, setH] = useState(null);
  useEffect(() => {
    const load = () => api.get("/health").then((r) => setH(r.data)).catch(() => setH({ status: "unreachable" }));
    load();
    const id = setInterval(load, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return h;
}
